import { useEffect, useState } from "react"
import * as api from '../../../../../Auth/auth'
import Ubam from "./Ubam";

//const FileContext = createContext()

export default function GetArchiveUbam() {
  
       const [data, setData] = useState([])
  
       useEffect(() => {

        async function axios_get() {
            const response = await api.genarchive()
            const urls = response
            setData(urls);
           
            }
    
        axios_get()

    }, []);
     
const sample = data.map(i => i.sample)
const date = data.map(i => i.test_date)
const seq = data.map(i => i.sequencer)
//const r1 = data.map(i => i.R1_file)
//const r2 = data.map(i => i.R2_file)
const ubam = data.map(i => i.Unmapped_BAM)
//const cram = data.map(i => i.CRAM_file)
//const crai = data.map(i => i.CRAM_index_file)
//const vcf = data.map(i => i.vcf_file)
//const vcf_index = data.map(i => i.vcf_index_file)


const gen_urls = [sample, date, seq, ubam, ]


    return (
  
            <div>
             <Ubam data={gen_urls}  />
            </div>
        
            )
 }


/*     

<FileContext.Provider value={urls}> 

                    <IgvAlignments data={urls}  /> 
               
    </FileContext.Provider>    
    
*/